import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { FormatAsPhoneNumberFunction } from './formatAsPhoneNumber.types';

/**
 * The `formatAsPhoneNumber` function formats a phone number string or number as a national US
 * phone number. When `discrete` is `true`, all digits except the last 4 are replaced with `X`.
 *
 * To view the type definition, click {@link FormatAsPhoneNumberFunction here}.
 */
export const formatAsPhoneNumber: FormatAsPhoneNumberFunction = (phoneNumber, discrete = false) => {
    let number = (phoneNumber && parsePhoneNumberFromString(phoneNumber.toString(), 'US')
        ?.formatNational()) || '';

    if (number && discrete) {
        const front = number.substring(0, number.length - 4)
            .replace(/[0-9]/g, 'X');
        const back = number.slice(number.length - 4);
        number = front + back;
    }

    return number;
};
